/**
 * @file 職種選択のラジオボタンの変更を監視
 */
'use strict'

/**
 * @classname OccupationRadioInput
 * @classdesc 職種選択のラジオボタンの変更を監視
 */
export default class OccupationRadioInput {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-toggle-password')
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`)
		this._$e = $e
		this.displayText = $('.selected-occupation-text')
		this.hiddenInput = $('.occupation-validation')
		this._$e.on('change', () => this.onChange())
	}

	/**
	 * onClickのコールバック
	 *
	 * @memberof OccupationRadioInput
	 * @return {undefined}
	 */
	onChange() {
		console.log(`${this.constructor.name}.onClick :: value`)
		this.hiddenInput.remove()
		if (this._$e.is(':checked')) {
			const text = this._$e.closest('label').text()
			this.displayText.html(text)
		}
	}
}
